import { useQuery } from '@apollo/client';
import { Select, Label, FluentProvider, Spinner, webLightTheme } from '@fluentui/react-components';
import React, { ChangeEvent } from 'react';
import IDropdownOption from '../../../utils/types/IDropdownOption';
import { GET_MS_REPORTING_SALES_LOCATIONS } from '../../../utils/statApi/CompanyCreationApi';
import LoadingErrorMessage from '../../common/errorContent/LoadingErrorMessage';

interface IMsReportingSalesLocationDropDownProps {
  defaultValue: string;
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
}

const MsReportingSalesLocationDropDown = ({
  defaultValue,
  onChange,
}: IMsReportingSalesLocationDropDownProps): JSX.Element => {
  const { data, loading, error } = useQuery(GET_MS_REPORTING_SALES_LOCATIONS);

  return (
    <>
      <LoadingErrorMessage loading={loading} error={error} />
      {loading && !error && (
        <>
          <br />
          <Spinner label="Loading Reporting Locations" />
        </>
      )}
      {!loading && !error && data?.msReportingSalesLocations && (
        <FluentProvider theme={webLightTheme}>
          <Label id="msReportingSalesLocation">Sales Location for MS Reporting Region</Label>
          <Select
            aria-labelledby="msReportingSalesLocation"
            defaultValue={defaultValue || ''}
            onChange={onChange}
          >
            <option value="">-- Select Location --</option>
            {data.msReportingSalesLocations.map((location: IDropdownOption) => (
              <option key={location.key} value={location.key}>
                {location.text}
              </option>
            ))}
          </Select>
        </FluentProvider>
      )}
    </>
  );
};

export default MsReportingSalesLocationDropDown;
